module.exports = __webpack_public_path__ + "img/BM.99677eb5.png";